import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {AbstractStorage} from '@specials/localstorage';

import {userIdKey} from '@/constants';
import {CookieStorage} from '@/services/CookieStorage/CookieStorage';
import {ProjectApiHeaders} from '@/services/ProjectAuthApi/ProjectApiHeaders';
import {QueryStringService} from '@/services/QueryStringService/QueryStringService';

export class TracingService {
  constructor(
    private projectApiHeaders: ProjectApiHeaders,
    private queryStringService: QueryStringService,
    private localStorageService: AbstractStorage,
    private cookieStorage: CookieStorage,
  ) {}
  public setMbData = (): void => {
    const data = {
      mbversion: this.queryStringService.getMobileVersion() || this.localStorageService.getItem('mbversion') || '',
      platform: this.queryStringService.getPlatform() || this.localStorageService.getItem('platform') || '',
      auth: this.queryStringService.getAuth() || this.localStorageService.getItem('auth') || '',
    };

    Object.entries(data).map(([key, value]) => {
      this.localStorageService.setItem(key, value);
    });

    this.projectApiHeaders.setMbHeadersData(data);
  };

  public setUserIdData = (id: string | undefined): void => {
    const userId = id || '';

    if (userId) {
      this.localStorageService.setItem(userIdKey, userId);
      this.cookieStorage.setUserId(userId);
    }

    const currentUserId = userId || this.localStorageService.getItem(userIdKey) || this.cookieStorage.getUserId();

    this.projectApiHeaders.setUserIdData(currentUserId);
  };
}

injected(
  TracingService,
  DI_TOKENS.projectApiHeaders,
  DI_TOKENS.queryStringService,
  DI_TOKENS.localStorageService,
  DI_TOKENS.cookieStorage,
);
